// extracted by mini-css-extract-plugin
export default {"article":"Article_article__ODF1L","articleFooter":"Article_articleFooter__-fijM"};